import { Input } from "antd";
import { ReactComponent as SearchIcon } from "../../../../images/icons/section-icons/search-icon.svg";

const DEFAULT_PLACEHOLDER = 'Search by Partner Code, Btag or Party ID';

const BtagTableHeader = ({ filter, setFilter, placeholder = DEFAULT_PLACEHOLDER }) => (
  <div className="btag-header-block">
    <div className="btag-header-block__search-wrapper">
      <Input
        placeholder={placeholder}
        onChange={(e) => setFilter(e.target.value)}
        allowClear
        prefix={<SearchIcon />}
        value={filter.searchValue}
        className="filter-input__search"
      />
    </div>
  </div>
);

export default BtagTableHeader;
